import { ulid } from 'ulid'

export default class AppAction {
  id: string = ulid()
  title: string = ''
  message: string = ''
  link: string = ''
  href: string = ''
}
